import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

function Leaderboard2k26Promo(props) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const isFomo = (brandId == 39 || brandId == 40)

    return (
        <>
            <InformationWrapper>
                <Container>
                    <SectionTitle $isFomo={isFomo}>
                        2026 Leaderboard &#45; Climb & Win Big
                    </SectionTitle>

                    <div className='staticImg2'>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.leaderboardMarPrizes}`}
                            alt="Cricket One"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </div>

                    <TermsSection>
                        <TermsTitle $isFomo={isFomo}>Terms &amp; Conditions</TermsTitle>
                        {(isFomo) ? <UnderLine></UnderLine> : ""}
                        <TermsList>
                            <li>✪ Top 10 weekly and Top 3 monthly players win</li>
                            <li>✪ Weekly & monthly prize pools apply</li>
                            <li>✪ To be eligible for weekly or monthly leaderboard prizes, players must <br />achieve a minimum qualifying turnover amount of {brandId === 61 ? "$1000" : "₹100,000"} during the <br /> promotion period</li>
                            <li>✪ Weekly winnings credited every Monday at 12 PM</li>
                            <li>✪ Monthly winnings credited on 7th of the following month</li>
                            <li>✪ Calculation period: Sunday to Saturday</li>
                            <li>✪ Valid until 31 May 2026</li>
                            <li>✪ General leaderboard rules apply</li>
                        </TermsList>
                    </TermsSection>
                </Container>

            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(Leaderboard2k26Promo));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 4rem 0 5rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.leaderboard2k26PromoMainInnerBg")});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    color: #fff;
    text-transform: capitalize;

    .staticImg2 {
        width: 100%;
        max-width: 910px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            max-width: 100%;
        }
    }
`;

const UnderLine = styled.div`
    height: 1px;
    width: 184px;
    background: radial-gradient(#f5e7ce 0%, rgba(153, 153, 153, 0.00) 50%);
    margin: 0 auto;
    margin-bottom: 1.5rem;
`;

const Container = styled.div`
    width: 100%;
    max-width: 1100px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

const SectionTitle = styled.h2<{ $isFomo?: boolean }>`
  text-align: center;
  font-size: 18px;
  margin: 0 0 30px;
  color: ${theme('palette.Leaderboard2k26PromoSectionTitleColor')};
  text-transform: capitalize;
  font-weight: 700;

  ${({ $isFomo }) =>
        $isFomo
            ? `
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 115.57%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
      `
            : ``
    }
`;

const TermsSection = styled.section`
    border-radius: 14px;
    border: ${theme('palette.Leaderboard2k26PromoTermsSectionBrdr')};
    background: ${theme('palette.Leaderboard2k26PromoTermsSectionBcColor')};
    padding: 1rem 5rem;
    margin-top: 2rem;
    text-align: center;
`;

const TermsTitle = styled.h3<{ $isFomo?: boolean }>`
  font-size: 22px;
  color: ${theme('palette.Leaderboard2k26PromoSectionTitleColor')};
  margin-bottom: 20px;

  ${({ $isFomo }) =>
        $isFomo
            ? `
        background: linear-gradient(180deg, #FED546 18.06%, #FE7C23 115.57%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
      `
            : ``
    }
`;

const TermsList = styled.ol`
  margin: 0 auto;
  padding-left: 22px;
  text-align: left;
  max-width: 640px;
  font-size: 14px;
  line-height: 1.8;
  color: #fff;
  list-style: none;

  strong {
    font-family: 'Inter-Bold';
  }
`;